import { axiosInstance } from '@applyboard/ui-utils';
export var createBulkNotesAction = function createBulkNotesAction(note_id, application_ids, is_admin_tab) {
  return axiosInstance.post('/api/v0.1/notes/bulk_create', {
    note_id: note_id,
    application_ids: application_ids,
    is_admin_tab: is_admin_tab
  });
};
export var createBulkNoteTemplateAction = function createBulkNoteTemplateAction(note_template_id, application_ids, is_admin_tab) {
  return axiosInstance.post('/api/v0.1/notes/bulk_create', {
    note_template_id: note_template_id,
    application_ids: application_ids,
    is_admin_tab: is_admin_tab
  });
};